module.exports = __webpack_public_path__ + "static/media/video-thumbnail-tabletPro-en.1bf241f8.png";